<template>
  <div class="outer" :style="'background-image: url('+bg+')'">

<!--
    <div class="bg_select">
      <el-select v-model="bg" placeholder="切换背景图" size="mini" @change="saveSkin">
        <el-option
            v-for="item in bgOptions"
            :key="item.name"
            :label="item.name"
            :value="item.src">
        </el-option>
      </el-select>
    </div>
-->

    <div class="login_box">

      <div class="box_left">
        <div class="line top"></div>
        <div class="img_logo">
          <div style="width: 300px; margin: 0 auto;">
            <img src="/static/imgs/ysh_logo.png"/>
          </div>
        </div>
        <div class="line bottom"></div>
      </div>

      <div class="box_right">
        <h2>心理亦笙后台管理</h2>

        <el-form v-model="loginForm"
                 v-loading="form_loading"
                 element-loading-text="登录中"
                 @keyup.enter.native="doLogin"
                 style="margin-top: 40px; padding: 0 12px;">
          <h3>登录</h3>
          <el-form-item>
            <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item style="position: relative">
            <el-input v-model="loginForm.code" placeholder="请输入验证码"></el-input>
            <img class="codeImg" :src="code.src" alt="验证码" title="验证码" @click="initCaptchaCode">
          </el-form-item>
          <el-form-item>
            <el-button class="login_btn" type="primary" @click="doLogin">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
import base from '@/api/common';
import qs from "qs";

export default {
  name: "admin_login",
  data() {
    return {
      bg: '/static/bg_ocean.png',
/*      bgOptions: [
        {name: '城堡', src: '/static/bg/bg_castle.jpg'},
        {name: '房子', src: '/static/bg/bg_house.jpg'},
        {name: '大海', src: '/static/bg/bg_ocean.jpg'},
        {name: '云海', src: '/static/bg/bg_seas_cloud.jpg'},
        {name: '船', src: '/static/bg/bg_ship.jpg'},
        {name: '游泳', src: '/static/bg/bg_swimming.jpg'},
      ],*/
      code: {
        token: '',
        src: '',
      },
      loginForm: {
        username: '',
        password: '',
        code: '',
      },
      form_loading: false,
    }
  },
  mounted: function () {
    // 初始化验证码
    this.initCaptchaCode();
    let skin = localStorage.getItem('login_skin');
    if (skin) {
      this.bg = skin;
    }
    // 尝试自动登录
    let accessToken = localStorage.getItem("access_token");
    let userType = localStorage.getItem("user_type");
    if (accessToken && userType && userType == 3) {
      this.form_loading = true;
      this.$router.push('/admin/welcome');
    }
  },
  methods: {
    saveSkin(skinSrc) {
      localStorage.setItem("login_skin", skinSrc);
    },
    initCaptchaCode() {
      this.$ajax.post(base.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          this.code.token = res.data.token;
          this.code.src = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        this.$message.error('获取失败');
      });
    },
    doLogin() {
      if ($.trim(this.loginForm.username).length === 0) {
        this.$message.warning("用户名不能为空");
        return;
      }
      if ($.trim(this.loginForm.password).length === 0) {
        this.$message.warning("密码不能为空");
        return;
      }
      if ($.trim(this.loginForm.code).length === 0) {
        this.$message.warning("验证码不能为空");
        return;
      } else if ($.trim(this.loginForm.code).length !== 4) {
        this.$message.warning("验证码不正确");
        return;
      }
      let username = this.loginForm.username,
          password = this.loginForm.password,
          code = this.loginForm.code,
          token = this.code.token;

      let params = {
        grant_type: "password",
        username: username + "#3",
        password: password,
        scope: "all",
        token: token,
        code: code,
        client_id: "web",
        client_secret: "secret"
      };
      let that = this;
      this.form_loading = true;
      this.$ajax.post(base.api.login, qs.stringify(params)).then(res => {
        if (res.data && res.data.access_token) {
          localStorage.clear();
          localStorage.setItem("access_token", res.data.access_token);
          localStorage.setItem("refresh_token", res.data.refresh_token);
          localStorage.setItem("expires_in", res.data.expires_in);
          localStorage.setItem("get_token_date", new Date().getTime());
          localStorage.setItem("user_type", 3);
          localStorage.setItem("login_skin", that.bg);
          that.$router.push('/admin/sysIndex');
        } else {
          that.initCaptchaCode();
          if (res.data.status === 'fail') {
            //验证码错误
            that.$message.error(res.data.message);
          } else if (res.data.error) {
            that.$message.error(res.data.error_description);
          }
          that.form_loading = false;
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error('登录失败');
      })
    },
  }
}
</script>


<style scoped>

.outer {
  height: 99vh;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  background-position: bottom;
}

.bg_select {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 100px;
}

.login_box {
  width: 1000px;
  height: 500px;
  box-sizing: border-box;
  box-shadow: 0 0 4px 1px #7e7e7e;
  margin: calc(50vh - 250px) auto 0;
  border-radius: 4px;
}

.box_left, .box_right {
  float: left;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.box_left {
  width: 55%;
  background: rgba(255, 255, 255, 0.3);
}

.box_left img {
  width: 300px
}

.box_right {
  width: 45%;
  background: #FFF;
  padding: 60px
}


.line {
  height: 0;
  border: 1px solid #2196F3;
}

.line.top {
  margin: 50px 0 0 50px;
  width: 300px;
}

.img_logo {
  width: 100%;
  text-align: center;
  margin: 110px auto;
}

.line.bottom {
  margin-left: 50px;
  width: 100px;
}

.box_right h2 {
  text-align: center;
  font-weight: 500;
  font-size: 32px;
  letter-spacing: 2px;
}

.box_right h3 {
  color: #2196F3;
  margin-bottom: 18px;
  padding-left: 14px;
}

.box_right >>> input.el-input__inner {
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none
}

.box_right button.login_btn {
  height: 32px;
  line-height: 32px;
  padding: 0;
  width: 120px;
}

img.codeImg {
  position: absolute;
  right: 0;
  top: -4px;
  width: 120px;
  cursor: pointer;
}

</style>
